
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PagesCoreFooter extends Vue {
  get year(): number {
    return new Date().getFullYear();
  }
}
